import React from 'react';
import {withStyles} from '@material-ui/core/styles';

import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import i18n from "../../i18n";
import Grid from "@material-ui/core/Grid/Grid";
import HistoryListItem from "../../components/History/ListItem.jsx";
import Table from "@material-ui/core/Table/Table";
import TableBody from "@material-ui/core/TableBody/TableBody";
import Paper from "@material-ui/core/Paper/Paper";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableRow from "@material-ui/core/TableRow/TableRow";
import {FormattedDate} from "react-intl";

const HistoryShow = ({classes, histories}) => {
    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('history.title')}
            />

            <Paper className={classes.layout}>
                <Grid container spacing={24}>
                    <Grid item sm={12}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Notiz</TableCell>
                                    <TableCell>User</TableCell>
                                    <TableCell>Datum</TableCell>
                                    <TableCell className={classes.columnCenter}>Änderungen</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {histories && histories.map((history, idx) => (
                                    <HistoryListItem
                                        key={idx}
                                        history={history}
                                    />
                                )
                            )}
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            </Paper>
        </Layout>
    )
};

const styles = theme => ({
    layout: {
        width: 'auto',
    },
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
    },
    columnCenter: {
        textAlign: "center",
    },
});


export default withStyles(styles)(HistoryShow);


// WEBPACK FOOTER //
// ./resources/assets/js/pages/history/Show.jsx